import { Client, ClientType } from '@lockton-apps/shared/interfaces';

export enum MockedClientDefaultId {
  LsosDefault = 11,
  NorwayDefaultCorporateHealthBusiness = 31,
  NorwayDefaultCorporateHealthPrivate = 32,
}

export const MOCKED_CLIENTS_DEFAULT: Client[] = [
  // LSOS
  {
    id: MockedClientDefaultId.LsosDefault,
    portalId: 1,
    clientType: ClientType.Individual,
    clientData: {
      insuredName: 'Lsos individual client 1',
    },
  },

  // NORWAY
  {
    id: MockedClientDefaultId.NorwayDefaultCorporateHealthBusiness,
    portalId: 3,
    clientData: {
      insuredName: 'Norway corporate client 1',
    },
    clientType: ClientType.Company,
  },
  {
    id: MockedClientDefaultId.NorwayDefaultCorporateHealthPrivate,
    portalId: 3,
    clientData: {
      insuredName: 'Norway individual client 1',
    },
    clientType: ClientType.Individual,
  },
] as Client[];
